import { DateDataBaseType } from "./database";

export type User = {
  id?: number;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRole;
  active: boolean;
  phone?: string;
  company?: string;
  twoFAEnabled?: boolean;
  accountActivateAt?: Date;
  isPremium?: boolean;
  siteIds?: number[];
  sites?: SiteSummary[];
}

export enum UserRole {
  admin = "admin",
  site_admin = "site_admin",
  operator = "operator"
}

export type SiteSummary = {
  id: number;
  name: string;
};

export type EditUser = Omit<User, "active"> & { password?: string };

export type UserDBType = User & DateDataBaseType & {id: number};
export type UsersListType = {
  totalItems: number;
  totalPages: number;
  page: number;
  limit: number;
  orderby: string;
  order: 'ASC' | 'DESC';
  nextPage: number;
  prevPage: number;
  possibleOrderby: string[];
  data: UserDBType[];
}
